import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";
interface IAllPartnerServiceProps extends ICommonServiceProps {
  partnerId?: number | string;
}
export const useGetAllPartnerServices = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
  partnerId = "",
}: IAllPartnerServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allPartnersService = useQuery({
    queryKey: [
      ...CACHE_KEYS.PARTNERS,
      page,
      debouncedQuery,
      per_page,
      partnerId,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PARTNERS,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[partner_id]": partnerId,
          page,
          include:
            "city,state,parent,parent.city,parent.state,paymentGateway,plans,policies.product",
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allPartnersService },
    states: { searchQuery, setSearchQuery },
  };
};

export const useGetSinglePartnerServices = () => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const partnerId = urlQueries["partner-id"] || "";
  const singlePartnerService = useQuery({
    queryKey: [...CACHE_KEYS.SINGLE_PARTNER, partnerId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.PARTNERS}/${partnerId}`,
      }),
    enabled: partnerId ? true : false,
  });

  return {
    services: { singlePartnerService },
  };
};
